import { observer } from 'mobx-react-lite'
import {
  ManageSupportingItemsModalForm,
  SupportingItemSelector,
} from '@/features/inventory/admin/components/InventoryItemForm/ManageSupportingItemsModalForm'
import {
  type ManageSupportingItemsModalFormViewModel,
  type SupportingItemViewModel,
} from '@/features/inventory/admin/inventory-item-dialog/ManageSupportingItemsModalFormViewModel'

export interface ManageSupportingItemsModalFormContainerProps {
  vm: ManageSupportingItemsModalFormViewModel
  testId?: string
}

export const ManageSupportingItemsModalFormContainer = observer(
  function ManageSupportingItemsModalFormContainer({
    vm,
    testId,
  }: ManageSupportingItemsModalFormContainerProps) {
    return (
      <ManageSupportingItemsModalForm
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        totalSelected={vm.totalSelected}
        testId={testId}
        inputItems={vm.inputSupportingItemVms.map((si) => (
          <SupportingItemSelectorContainer key={si.key} vm={si} />
        ))}
        documentTypeItems={vm.documentTypeSupportingItemVms.map((si) => (
          <SupportingItemSelectorContainer key={si.key} vm={si} />
        ))}
      />
    )
  },
)

interface SupportingItemSelectorContainerProps {
  vm: SupportingItemViewModel
}

const SupportingItemSelectorContainer = observer(
  function SupportingItemSelectorContainer({
    vm,
  }: SupportingItemSelectorContainerProps) {
    return (
      <SupportingItemSelector
        name={vm.name}
        requested={vm.requested}
        onToggleRequested={vm.toggleRequested}
        required={vm.required}
        onToggleRequired={vm.toggleRequired}
      />
    )
  },
)
